import { render, staticRenderFns } from "./ChangeSubscription.vue?vue&type=template&id=85fed0e0&"
import script from "./ChangeSubscription.vue?vue&type=script&lang=js&"
export * from "./ChangeSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports